"use strict";

var fetchFactory = require("../common");
var errorMessageFormatter = require("./errorMessageFormatter");
module.exports = clientFetchFactory;
var defaultHeaders = {
  accept: 'application/json'
};
var defaultContextMapping = {
  fromService: 'x-from-service',
  fromServiceVersion: 'x-from-service-version',
  ip: 'x-forwarded-for',
  authorization: 'authorization'
};
function clientFetchFactory(_ref) {
  var config = _ref.config,
    logger = _ref.logger,
    errorFactory = _ref.errorFactory;
  return fetchFactory({
    config: config,
    contextMapping: defaultContextMapping,
    logger: logger,
    defaultHeaders: defaultHeaders,
    errorFactory: errorFactory,
    errorMessageFormatter: errorMessageFormatter
  });
}
//# sourceMappingURL=index.js.map